import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const WorkspaceSchema = withDefaults({
  type: 'workspace',
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'customAttributes',
    },
    {
      kind: 'hasMany',
      name: 'employees',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'users',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'agents',
      type: 'agent',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default WorkspaceSchema;
